import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-job-pointe-settings-paging',
  templateUrl: './job-pointe-settings-paging.component.html',
  styleUrls: ['./job-pointe-settings-paging.component.scss'],
})
export class JobPointeSettingsPagingComponent implements OnInit {
  private _links: any;

  fromCount: number = 0;
  toCount: number = 0;
  totalCount: number = 0;
  pageList: Array<number> = [];

  @Input()
  set links(value: any) {
    this._links = value;
    this.parseValues(this._links);
  }
  get links(): any {
    return this._links;
  }

  @Output() navigation = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  parseValues(data): void {
    if (data?.currentPage) {
      this.fromCount = data.from;
      this.toCount = data.to;
      this.totalCount = data.totalCount;

      this.pageList = this.getPageRangeList(data);
    }
  }

  getPageRangeList(data): any[] {
    const pagesPerGroup = data.pageCountPerGroup - 1;
    const first = 1;
    const last = data.totalPages;
    const current = data.currentPage;
    let start = data.currentPage - 2;
    let end = data.currentPage + 2;

    if (current === last) start = last - pagesPerGroup;
    if (start < first) start = first;

    if (current === first) end = first + pagesPerGroup;
    if (end > last) end = last;

    const listLength = end - start + 1;

    const addPrevGroup = start - 1 > first ? true : false;
    const addNextGroup = end + 1 < last ? true : false;

    const pageRangeList: any[] = Array(listLength)
      .fill(0)
      .map((value, index) => start + index);

    if (addPrevGroup) pageRangeList.unshift('prevGroup');
    if (start !== first) pageRangeList.unshift(first);
    if (addNextGroup) pageRangeList.push('nextGroup');
    if (end !== last) pageRangeList.push(last);

    return pageRangeList;
  }

  isNumber(val): boolean {
    return typeof val === 'number';
  }

  performNavigation(event: Event, link): void {
    const page = typeof link == 'number' ? link : this.links[link];
    if (page !== this.links.currentPage) {
      this.navigation.emit(page);
    }
  }
}
